import React from "react";
import NavBarMenu from "../navBarMenu/navBarMenu";
import { Button } from "primereact/button";
import ContactInfo from "../contactInfo/ContactInfo";
import logoAulaABA from "../../../assets/img/LOGO-AULA-ABA-COLOR.png"
import "./NavBar.module.css";

const NavBar = (props) => {


  return (
    <div style={{ position:"fixed", zIndex:"1", width:"100%", top:0}}>
      <ContactInfo  />
      <NavBarMenu img={logoAulaABA} />
    </div>
  );
};
export default NavBar;
